import React from "react";
import { Chips } from "../../../chips/index.js";
import { useInputContext } from "../Input/Input.context.js";
import { useSelectedOptionsContext } from "./selectedOptionsContext.js";
const Option = ({ option }) => {
    const { isMultiSelect, removeSelectedOption } = useSelectedOptionsContext();
    const { focusInput } = useInputContext();
    const onClick = (e) => {
        e.stopPropagation();
        removeSelectedOption(option);
        focusInput();
    };
    if (!isMultiSelect) {
        return (React.createElement("div", { className: "navds-combobox__selected-options--no-bg" }, option.label));
    }
    return React.createElement(Chips.Removable, { onClick: onClick }, option.label);
};
const SelectedOptions = ({ selectedOptions = [], size, children, }) => {
    const { value } = useInputContext();
    const { isMultiSelect } = useSelectedOptionsContext();
    return (React.createElement(Chips, { className: "navds-combobox__selected-options", size: size },
        value.length === 0 || (isMultiSelect && selectedOptions.length)
            ? selectedOptions.map((option, i) => (React.createElement(Option, { key: option.label + i, option: option })))
            : [],
        children));
};
export default SelectedOptions;
//# sourceMappingURL=SelectedOptions.js.map